import Immutable from 'immutable';
import {
  CERTIFICATE_OF_COMPLETION,
  ASQA_ACCREDITED_CERTIFICATE,
  ACCREDIBLE_OPENCRED,
  ACCREDIBLE_OPENCRED_PAID,
  ACCREDIBLE_CERTIFICATE,
  ACCREDIBLE_CERTIFICATE_PAID,
} from '../Certification/constants';

export const validateCertificationData = (certificationData) => {
  const type = certificationData.get('type');
  let errors = Immutable.Map();
  switch (type) {
    case ACCREDIBLE_OPENCRED:
    case ACCREDIBLE_CERTIFICATE: {
      const displayName = certificationData.getIn(['data', 'displayName'], '');
      if (!displayName.length)
        errors = errors.set('displayName', 'This field is required');

      const description = certificationData.getIn(['data', 'description'], '');
      if (!description.length)
        errors = errors.set('description', 'This field is required');

      const website = certificationData.getIn(['data', 'website'], '');
      if (!website.length)
        errors = errors.set('website', 'This field is required');

      break;
    }
    case ACCREDIBLE_OPENCRED_PAID:
    case ACCREDIBLE_CERTIFICATE_PAID: {
      const displayName = certificationData.getIn(['data', 'displayName'], '');
      if (!displayName.length)
        errors = errors.set('displayName', 'This field is required');

      const description = certificationData.getIn(['data', 'description'], '');
      if (!description.length)
        errors = errors.set('description', 'This field is required');

      const website = certificationData.getIn(['data', 'website'], '');
      if (!website.length)
        errors = errors.set('website', 'This field is required');

      const price = parseFloat(certificationData.getIn(['data', 'price'], ''));
      if (Number.isNaN(price) || price <= 0)
        errors = errors.set('price', 'Please enter a price');

      break;
    }
    case CERTIFICATE_OF_COMPLETION:
    case ASQA_ACCREDITED_CERTIFICATE: {
      const price = parseFloat(certificationData.getIn(['data', 'price'], ''));
      if (Number.isNaN(price) || price <= 0)
        errors = errors.set('price', 'Please enter a price');

      break;
    }
    default:
      break;
  }
  return errors;
};
